import React from 'react';
import { PostModel } from '../NewsfeedModels';
import { Paper, Text } from 'library';
import { Grid, Divider } from '@material-ui/core';
import PostAttachments from '../Attachments/PostAttachments';
import { Colors } from 'library';
import ExistingPostActionBar from '../ActionBar/ExistingPostActionBar';
import Reactions from '../Reactions';
import ServiceOfferings from './Post/ServiceOfferings';
import Name from './Post/Name';
import Picture from './Post/Picture';
import ViewMore from './Post/ViewMore';

const Post = ({ post, commentsExpanded }: { post: PostModel; commentsExpanded?: boolean }) => {
    let postBackground = post.pinned ? Colors.mediumLime : '#fff';

    return (
        <Paper style={{ backgroundColor: postBackground, marginBottom: 20 }} key={post.content}>
            <Grid item xs={12}>
                <Grid container direction="row">
                    <Grid container direction="row">
                        <Grid container direction="row">
                            <Grid item>
                                <Picture post={post} />
                            </Grid>
                            <Grid item style={{ flexGrow: 1 }}>
                                <Grid container direction="row" justify="space-between">
                                    <Grid item>
                                        <Grid container direction="column">
                                            <Name post={post} />
                                            <ServiceOfferings user={post.user} />
                                            <Text variant="body3">{post.postAge || ''}</Text>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <ViewMore post={post} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {post.user_generated || post.user.role === 'PROVIDER' ? (
                                <Grid item xs={12}>
                                    <hr></hr>
                                </Grid>
                            ) : null}
                        </Grid>
                        {post.raw_content ? (
                            post.raw_content
                        ) : post.user_generated || post.user.role === 'PROVIDER' ? (
                            <Text variant="body1">{post.content}</Text>
                        ) : null}
                    </Grid>
                </Grid>
                <Grid container style={{ paddingLeft: 15, paddingRight: 15, paddingBottom: 10 }}>
                    <PostAttachments items={post.attachments} />
                    <Reactions reactions={post.reactions} />
                </Grid>
                <Divider style={{ backgroundColor: Colors.lightGrey }} />
                {!post.pinned ? (
                    <ExistingPostActionBar post={post} commentsExpanded={commentsExpanded || false} />
                ) : null}
            </Grid>
        </Paper>
    );
};

export default Post;
